import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { INTERCEPTOR_PROVIDER } from "./interceptors/interceptor-provider";
import { NavBarComponent } from "./nav-bar/nav-bar.component";
import { HeaderComponent } from "./header/header.component";
import { HomeComponent } from "./home/home.component";
import { ApprovedPRsComponent } from "./approved-prs/approved-prs.component";
import { PRDetailsComponent } from "./approved-prs/pr-details/pr-details.component";
import { TendersComponent } from "./tenders/tenders.component";
import { TenderDetailsComponent } from "./tenders/tender-details/tender-details.component";
import { CreateTenderComponent } from "./tenders/create-tender/create-tender.component";
import { PracticesComponent } from "./practices/practices.component";
import { PracticeDetailsComponent } from "./practices/practice-details/practice-details.component";
import { BidsComponent } from "./bids/bids.component";
import { BidDetailsComponent } from "./bids/bid-details/bid-details.component";
import { EvaluationsComponent } from "./evaluations/evaluations.component";
import { EvaluationScoringComponent } from "./evaluations/evaluation-scoring/evaluation-scoring.component";
import { EvaluationDetailsComponent } from "./evaluations/evaluation-details/evaluation-details.component";
import { AssignEvaluatorsComponent } from "./evaluations/assign-evaluators/assign-evaluators.component";
import { MeetingsComponent } from "./meetings/meetings.component";
import { CreateMeetingComponent } from "./meetings/create-meeting/create-meeting.component";
import { ViewMeetingComponent } from "./meetings/view-meeting/view-meeting.component";
import { JoinMeetingDialogComponent } from "./meetings/join-meeting-dialog/join-meeting-dialog.component";
import { MeetingSummaryDialogComponent } from "./meetings/meeting-summary-dialog/meeting-summary-dialog.component";
import { StartMeetingDialogComponent } from "./meetings/start-meeting-dialog/start-meeting-dialog.component";
import { MinutesOfMeetingComponent } from "./minutes-of-meeting/minutes-of-meeting.component";
import { MinutesOfMeetingDetailsComponent } from "./minutes-of-meeting/minutes-of-meeting-details/minutes-of-meeting-details.component";
import { MeetingSessionComponent } from "./meetings/meeting-session/meeting-session.component";
import { AdminMeetingDialogComponent } from "./meetings/admin-meeting-dialog/admin-meeting-dialog.component";
import { WaitingAttendanceDialogComponent } from "./meetings/waiting-attendance-dialog/waiting-attendance-dialog.component";
import { MinimizedMeetingIndicatorComponent } from "./meetings/minimized-meeting-indicator/minimized-meeting-indicator.component";
import { AgendaItemsComponent } from "./agenda-items/agenda-items.component";
import { CreateAgendaItemDialogComponent } from "./agenda-items/create-agenda-item-dialog/create-agenda-item-dialog.component";
import { ViewAgendaItemDialogComponent } from "./agenda-items/view-agenda-item-dialog/view-agenda-item-dialog.component";
import { FAQsComponent } from "./faqs/faqs.component";
import { ViewFAQComponent } from "./faqs/view-faq/view-faq.component";
import { CreateFAQDialogComponent } from "./faqs/create-faq-dialog/create-faq-dialog.component";
import { VendorsComponent } from "./vendors/vendors.component";
import { VendorDetailsComponent } from "./vendors/vendor-details/vendor-details.component";
import { LookupsComponent } from "./lookups/lookups.component";
import { CreateLookupDialogComponent } from "./lookups/create-lookup-dialog/create-lookup-dialog.component";
import { CategoryTreeComponent } from "./lookups/category-tree/category-tree.component";
import { CategoryDialogComponent } from "./lookups/category-tree/category-dialog/category-dialog.component";
import { UserManagementComponent } from "./user-management/user-management.component";
import { BidDocumentsDialogComponent } from "./meetings/bid-documents-dialog/bid-documents-dialog.component";
import { AuthenticationModule } from "../modules/authentication/authentication.module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ToastrModule } from "ngx-toastr";
import { TableModule } from "primeng/table";
import { ChartModule } from "primeng/chart";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        HttpClientModule,
        SharedModule,
        TranslateModule,
        AuthenticationModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        ChartModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            toastClass: 'toast-custom',
            tapToDismiss: true,
            closeButton: true
        })
    ],
    exports: [
        MinimizedMeetingIndicatorComponent
    ],
    declarations: [
        HeaderComponent,
        NavBarComponent,
        HomeComponent,
        ApprovedPRsComponent,
        PRDetailsComponent,
        TendersComponent,
        TenderDetailsComponent,
        CreateTenderComponent,
        PracticesComponent,
        PracticeDetailsComponent,
        BidsComponent,
        BidDetailsComponent,
        EvaluationsComponent,
        EvaluationScoringComponent,
        EvaluationDetailsComponent,
        AssignEvaluatorsComponent,
        MeetingsComponent,
        CreateMeetingComponent,
        ViewMeetingComponent,
        JoinMeetingDialogComponent,
        MeetingSummaryDialogComponent,
        StartMeetingDialogComponent,
        MeetingSessionComponent,
        AdminMeetingDialogComponent,
        WaitingAttendanceDialogComponent,
        MinimizedMeetingIndicatorComponent,
        AgendaItemsComponent,
        CreateAgendaItemDialogComponent,
        ViewAgendaItemDialogComponent,
        FAQsComponent,
        ViewFAQComponent,
        CreateFAQDialogComponent,
        MinutesOfMeetingComponent,
        MinutesOfMeetingDetailsComponent,
        VendorsComponent,
        VendorDetailsComponent,
        LookupsComponent,
        CreateLookupDialogComponent,
        CategoryTreeComponent,
        CategoryDialogComponent,
        UserManagementComponent,
        BidDocumentsDialogComponent
    ],
    providers: [
        INTERCEPTOR_PROVIDER
    ],
})
export class CoreModule { }
